import { StyleSheet, Text, View } from "react-native";

import type { UiTheme } from "../theme";
import { hiddenFromScreenReader } from "./hiddenFromScreenReader";

// The box at the left of a selectable row: an empty ring, or a tinted ring
// with a ✓. The SHAPE says it, never the colour alone. Drawn only: the row
// that holds it carries the role and the checked/selected state, so a screen
// reader hears the row once. Born in the exercise picker's multi-select
// (its "select dot"), shared with the program editor's selection (#336).
// #368: `order` draws the pick's number instead of the ✓ (the diary, where
// the order of the taps is the order of the days).
export function SelectMark({
  theme,
  checked,
  order,
}: {
  theme: UiTheme;
  checked: boolean;
  order?: number;
}) {
  const styles = makeStyles(theme);
  return (
    <View style={[styles.box, checked && styles.boxOn]} {...hiddenFromScreenReader()}>
      {checked ? (
        <Text style={order === undefined ? styles.check : styles.order}>
          {order === undefined ? "✓" : order}
        </Text>
      ) : null}
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: t } = theme;
  return StyleSheet.create({
    box: {
      width: 28,
      height: 28,
      borderRadius: 14,
      borderWidth: 2,
      // borderStrong: `border` is ~1.4:1 on surface, under the 3:1 a control
      // needs to be found (#368).
      borderColor: p.borderStrong,
      alignItems: "center",
      justifyContent: "center",
    },
    // Selection = brand100 tint + brand outline (not a full brand fill), per
    // the selection-cue convention. Colour budget S3.4.
    boxOn: { backgroundColor: p.brand100, borderColor: p.brand500 },
    check: { color: p.brand500, fontSize: t.sizes.sm, fontWeight: "900" },
    order: {
      color: p.brandText,
      fontSize: t.sizes.sm,
      fontWeight: "700",
      fontFamily: t.fonts.mono,
      fontVariant: ["tabular-nums"],
    },
  });
}
